const app = require('loginApp');
const Marionette = require('backbone.marionette'),
    template = require('./loginView.hbs'),
    M = require('shared/messages/messages'),
    getLanguage = require('shared/helpers/getLanguage');

module.exports = Marionette.View.extend({
    // This ensures that the div containing this view that gets inserted into the region has the proper class name.
    className: 'login-body-row',
    template: template,
    ui: {
        signIn: '#signIn'
    },
    behaviors: {
        WaitButton: {},
        LockForm: {},
    },
    events: {
        'click @ui.signIn': 'onSignIn'
    },
    templateContext: {
        M: M,
        isEnglish: getLanguage() !== 'es'
    },
    initialize: function (options) {
        // JB:
        // The following event trigger doesn't work for updating the tab title.
        // app.eventAggregator.trigger('domchange:title', 'Login to WellDrive');
        // Manually setting it is a workaround for now.
        document.title = M.loginTitle();
    },
    onSignIn: function (e) {
        e.preventDefault();
        // Marionette.Router seems to be unable to provide the query string when going through the default route, so I'm using 
        // window.location.search here instead to ensure that it works in all cases.
        let route = window.location.search.replace('?', '');
        app.authMgr.signIn(route);
    }
});
